export const ENABLE_PREVENTIVE_LOG_REQUEST = 'ENABLE_PREVENTIVE_LOG_REQUEST'
export const ENABLE_PREVENTIVE_LOG_SUCCESS = 'ENABLE_PREVENTIVE_LOG_SUCCESS'
export const ENABLE_PREVENTIVE_LOG_FAIL = 'ENABLE_PREVENTIVE_LOG_FAIL'
export const ENABLE_PREVENTIVE_LOG_RESET = 'ENABLE_PREVENTIVE_LOG_RESET'
